<template>
  <main>
    <tab-header/>
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
          <div class="row">
            <div class="col-12 parent">
              <div class="radio radio-inline">
                <input type="radio" v-model="searchType" id="search-type-1" value="1">
                <label for="search-type-1">區部調撥記錄查詢</label>
              </div>
              <div class="radio radio-inline">
                <input type="radio" v-model="searchType" id="search-type-2" value="2">
                <label for="search-type-2">單位調撥紀錄查詢</label>
              </div>
              <div class="radio radio-inline child-right">
                <label>※僅提供查詢近三個月的調撥紀錄</label>
              </div>
              <!-- <div class="radio radio-inline">
                <input type="radio" v-model="searchType" id="search-type-3" value="3">
                <label for="search-type-3">解鎖自招件可撥給非增員者</label>
              </div> -->
            </div>
          </div>
          <div class="form-group row mt-1" v-if="searchType==1">
              <label class="ml-2 label-text-center">篩選撥出單位</label>
              <div class="col-2">
                  <select class="form-control" v-model="cedvno3_out">
                    <option value="">全部</option>
                    <option
                    v-for="(unit, index) in allUnits"
                    :key="`dialout-unit-${index}`"
                    :value="unit.div_no.substring(0,3)">{{ `${unit.div_no.substring(0,3)} ${unit.div_short_name}` }}</option>
                  </select>
              </div>
              <label class="ml-3 label-text-center">篩選撥入單位</label>
              <div class="col-2">
                  <select class="form-control" v-model="cedvno3_in">
                    <option value="">全部</option>
                    <option
                    v-for="(unit, index) in allUnits"
                    :key="`dialin-unit-${index}`"
                    :value="unit.div_no.substring(0,3)">{{ `${unit.div_no.substring(0,3)} ${unit.div_short_name}` }}</option>
                  </select>
              </div>
              <div class="col-2">                                              
                <a @click="queryRegionalAllocationRecord()" class="btn btn-primary mt-0">查詢</a>
              </div>
          </div>
          <div class="form-group row mt-1" v-if="searchType==2">
              <label class="ml-2 label-text-center">篩選單位</label>
              <div class="col-2">
                  <select class="form-control" v-model="unit_cedvno3">
                    <option value="">請選單位</option>
                    <option
                    v-for="(unit, index) in allUnits"
                    :key="`dialout-unit-${index}`"
                    :value="unit.div_no.substring(0,3)">{{ `${unit.div_no.substring(0,3)} ${unit.div_short_name}` }}</option>
                  </select>
              </div>
              <div class="col-2">                                              
                <a @click="queryUnitsAllocationRecord()" class="btn btn-primary mt-0">查詢</a>
              </div>
          </div>
          <div :class="{'section-loading': isRegionalAllocationRecordLoading}" v-if="searchType==1">
            <table class="table datatable insurance-green table-striped table-bordered">
              <thead>
                <tr>
                  <th
                    class="sorting"
                    :class="(order.index==1 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(1)"
                  >原服務人員</th>
                  <th
                    class="sorting"
                    :class="(order.index==2 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(2)"
                  >撥出原因</th>
                  <th
                    class="sorting"
                    :class="(order.index==3 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(3)"
                  >新收費代號/服務人員</th>
                  <th
                    class="sorting"
                    :class="(order.index==4 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(4)"
                  >調撥者</th>
                  <th
                    class="sorting"
                    :class="(order.index==5 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(5)"
                  >調撥日期</th>
                  <th
                    class="sorting"
                    :class="(order.index==6 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(6)"
                  >調撥件數</th>
                </tr>
              </thead>
              <tbody v-if="!isRegionalAllocationRecordSortLoading">
                <tr v-for="(row, rid) in regionalAllocationRecordData" :key="`row-${rid}`">
                  <td>
                    <span>
                      {{row.agname_old}}
                    </span>
                    <br>
                    {{row.ceclcno_old}}
                  </td>
                  <td v-if="row.producer_segment !== 'R' && row.producer_segment !== 'S'">
                    {{row.code_nm}}
                  </td>
                  <td v-else-if="row.producer_segment == 'R'">
                    區部調撥(空代號)
                  </td>
                  <td v-else-if="row.producer_segment == 'S'">
                    區部調撥(未訪件)
                  </td>
                  <td>
                    <span>
                      {{row.agname_new}}
                    </span>
                    <br>
                    {{row.ceclcno_new}}
                  </td>
                  <td>
                      {{row.mgr_nm}}
                  </td>
                  <td>{{row.date}}</td>
                  <td>
                    <a
                      @click="openRechargeRecordDetailAndGetData(row)"
                      class="link text-underline"
                    >{{row.cnt}}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div :class="{'section-loading': isUnitsAllocationRecordLoading}" v-if="searchType==2">
            <table class="table datatable insurance-green table-striped table-bordered">
              <thead>
                <tr>
                  <th
                    class="sorting"
                    :class="(order.index==1 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(1)"
                  >原服務人員</th>
                  <th
                    class="sorting"
                    :class="(order.index==2 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(2)"
                  >撥出原因</th>
                  <th
                    class="sorting"
                    :class="(order.index==3 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(3)"
                  >新收費代號/服務人員</th>
                  <th
                    class="sorting"
                    :class="(order.index==4 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(4)"
                  >調撥者</th>
                  <th
                    class="sorting"
                    :class="(order.index==5 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(5)"
                  >調撥日期</th>
                  <th
                    class="sorting"
                    :class="(order.index==6 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(6)"
                  >調撥件數</th>
                </tr>
              </thead>
              <tbody v-if="!isUnitsAllocationRecordSortLoading">
                <tr v-for="(row, rid) in unitsAllocationRecordData" :key="`row-${rid}`">
                  <td>
                    <span>
                      {{row.agname_old}}
                    </span>
                    <br>
                    {{row.ceclcno_old}}
                  </td>
                  <td v-if="row.producer_segment !== 'R' && row.producer_segment !== 'S'">
                    {{row.code_nm}}
                  </td>
                  <td v-else>
                    區部調撥
                  </td>
                  <td>
                    <span>
                      {{row.agname_new}}
                    </span>
                    <br>
                    {{row.ceclcno_new}}
                  </td>
                  <td>
                      {{row.mgr_nm}}
                  </td>
                  <td>{{row.date}}</td>
                  <td>
                    <a
                      @click="openRechargeRecordDetailAndGetData(row)"
                      class="link text-underline"
                    >{{row.cnt}}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <div :class="{'section-loading': isApproveRecordLoading}" v-if="searchType==2">
            <table class="table datatable insurance-green table-striped table-bordered">
              <thead>
                <tr>
                  <th
                    class="sorting"
                    :class="(order.index==1 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(1)"
                  >要保人</th>
                  <th
                    class="sorting"
                    :class="(order.index==2 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(2)"
                  >原服務人員</th>
                  <th
                    class="sorting"
                    :class="(order.index==3 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(3)"
                  >覆核原因</th>
                  <th
                    class="sorting"
                    :class="(order.index==4 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="columnSorting(4)"
                  >覆核日期</th>
                  <th>覆核明細</th>
                </tr>
              </thead>
              <tbody v-if="!isApproveRecordSortLoading">
                <tr v-for="(row, rid) in approveRecordData" :key="`row-${rid}`">
                  <td>{{row.ceapcnm}}</td>
                  <td>
                    {{row.clcid_nm}}
                    <br>
                    {{row.clcno}}
                  </td>
                  <td>{{row.kind}}</td>
                  <td>{{row.cfm_date}}</td>
                  <td>
                    <a @click="openApproveDetailAndGetData(row)" class="link text-underline">查詢</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div> -->
        </div>
      </div>
    </div>

    <transfer-modal
      :open="transferModalOpen"
      :detailList="rechargeRecordDetailData"
      :isLoading="isRechargeRecordDetailLoading"
      @close="panelClose('transferModalOpen')"
    />

    <check-modal
      :open="checkModalOpen"
      :dataType="approveRecordDetailType"
      :detailData="approveRecordDetailData"
      :isLoading="isApproveRecordDetailLoading"
      @submit="closeDetailAndOpenContactInfo"
      @close="panelClose('checkModalOpen')"
    />

    <connect-data-modal
      :open="connectModalOpen"
      :loading="isContactInfoLoading"
      :detailData="contactInfoData"
      @close="panelClose('connectModalOpen')"
    />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import DialOutPersonModal from "@/desktop/components/manager/DialOutPersonModal";
import DialInPersonModal from "@/desktop/components/manager/DialInPersonModal";
import TransferModal from "@/desktop/components/manager/TransferModal";
import CheckModal from "@/desktop/components/manager/CheckModal";
import ConnectDataModal from "@/desktop/components/manager/ConnectData";
import TabHeader from "@/desktop/components/manager/TabHeader";
import WarningModal from "@/desktop/components/WarningModal";
import Avatar from "@/components/Avatar";
import Level from "@/components/Level";
import {
  queryRechargeRecord,
  queryRechargeRecordDetail
} from "../../../service";
import {
  queryLostConfirmDetail,
  queryNoticeExcludeDetail,
  queryEstrangeExcludeDetail,
  queryBelowEstrangePolicyContactInfo,
  doQueryResignList
} from "../../../service";

export default {
  name: "TransferTab2",
  mixins: [commonMixin],
  components: {
    TabHeader,
    DialOutPersonModal,
    DialInPersonModal,
    WarningModal,
    Level,
    Avatar,
    TransferModal,
    CheckModal,
    ConnectDataModal
  },
  computed: {
    ...mapGetters(["News", "Videos", "QueryKeyword"])
  },
  data() {
    return {
      order: {
        index: 4,
        asc: false
      },
      searchType: 1,

      // RechargeRecordModal
      transferModalOpen: false,
      regionalAllocationRecordData: [],
      isRegionalAllocationRecordLoading: true,
      isRegionalAllocationRecordSortLoading: false,
      rechargeRecordDetailData: [],
      isRechargeRecordDetailLoading: true,

      allUnits: [], //區部轄下單位清單
      cedvno3_out: '', //篩選區部調撥撥出單位
      cedvno3_in: '', //篩選區部調撥撥入單位
      unit_cedvno3: '', //篩選單位調撥

      // ApproveRecordModal
      checkModalOpen: false,
      approveRecordData: [],
      unitsAllocationRecordData: [],
      isUnitsAllocationRecordLoading: false,
      isUnitsAllocationRecordSortLoading: false,
      isApproveRecordSortLoading: false,
      approveRecordDetailType: 1,
      approveRecordDetailData: [],
      isApproveRecordDetailLoading: true,

      // ConnectDataModal
      connectModalOpen: false,
      contactInfoData: {},
      isContactInfoLoading: true,
      // ResignUnlockRecord
      resignUnlockRecord: [],
      isResignUnlockLoading: false,
      form:[],
      yearOpt: [1,2,3]
    };
  },
  watch: {
    /**
     * 查詢相對應的資料
     * @param {*} val 
     */
    searchType: function(val) {
      // 3: 解鎖自招件可撥給非增員者
      // if (val === "3") {
      //   this.initResignUnlockRecord();
      // }
    }
  },
  methods: {
    ...mapActions([
      "loadNews",
      "loadVideos",
      "setPageLock",
      "updateQueryKeyword"
    ]),
    columnSorting(i) {
      //切換表頭圖案
      if (this.order.index == i) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.asc = true;
      }
      this.order.index = i;

      //data排序
      switch (i) {
        case 1:
          if(this.searchType == 1) {
            this.regionalAllocationRecordData.sort(this.sortCompareFun("agname_old", "date"))
          } else {
            this.unitsAllocationRecordData.sort(this.sortCompareFun("agname_old", "kind"));
          }
          break;
        case 2:
          if(this.searchType == 1) {
            this.regionalAllocationRecordData.sort(this.sortCompareFun("code_nm", "agname_old"))
          } else {
            this.unitsAllocationRecordData.sort(this.sortCompareFun("clcid_nm", "ceapcnm"));
          }
          break;
        case 3:
          if(this.searchType == 1) {
            this.regionalAllocationRecordData.sort(this.sortCompareFun("agname_new", "agname_old"))
          } else {
            this.unitsAllocationRecordData.sort(this.sortCompareFun("agname_new", "agname_old"));
          }
          break;
        case 4:
          if(this.searchType == 1) {
              this.regionalAllocationRecordData.sort(this.sortCompareFun("mgr_nm", "agname_old"))
          } else {
              this.unitsAllocationRecordData.sort(this.sortCompareFun("mgr_nm", "agname_old"));
          }
          break;
        case 5:
          if(this.searchType == 1) {
              this.regionalAllocationRecordData.sort(this.sortCompareFun("date", "agname_old"))
          } else {
              this.unitsAllocationRecordData.sort(this.sortCompareFun("date", "agname_old"));
          }
          break;
        case 6:
          if(this.searchType == 1) {
              this.regionalAllocationRecordData.sort(this.sortCompareFun("cnt", "agname_old"))
          } else {
              this.unitsAllocationRecordData.sort(this.sortCompareFun("cnt", "agname_old"));
          }
          break;
        default:
          break;
      }

      // for 難字 update
      if(this.searchType == 1) {
        let cacheList = [...this.regionalAllocationRecordData]
        this.regionalAllocationRecordData = []
        this.isRegionalAllocationRecordSortLoading = true
        setTimeout(() => {
          this.regionalAllocationRecordData = cacheList
          this.isRegionalAllocationRecordSortLoading = false
          this.registerHanlink()
        }, 200)
      } else {
        let cacheList = [...this.unitsAllocationRecordData]
        this.unitsAllocationRecordData = []
        this.isUnitsAllocationRecordLoading = true
        setTimeout(() => {
          this.unitsAllocationRecordData = cacheList
          this.isUnitsAllocationRecordLoading = false
          this.registerHanlink()
        }, 200)
      }
    },
    compareWithDivNo(clcNo, divNo){
      //divNo第三碼若為4，須調整為5做比較
      if (divNo[2] === '4') {
        divNo = divNo.slice(0, 2) + '5' + divNo.slice(3);
      }
      return clcNo.slice(0,3) == divNo.slice(0,3)
    },
    sortCompareFun(mainProperty, subProperty = null) {
      let sortOrder = 1;
      if (!this.order.asc) {
        sortOrder = -1;
      }
      return function(a, b) {
        let result =
          a[mainProperty] < b[mainProperty] ? -1 : a[mainProperty] > b[mainProperty] ? 1 : 0;
        if (result == 0 && subProperty != null) {
          result = a[subProperty] < b[subProperty] ? -1 : a[subProperty] > b[subProperty] ? 1 : 0;
        }
        return result * sortOrder;
      };
    },
    //==================== 各頁籤功能 ====================
    openRechargeRecordDetailAndGetData(target) {
      this.isRechargeRecordDetailLoading = true;
      queryRechargeRecordDetail(
        this.$store.state.userInfo.id,
        target.ceclcid_old,
        target.ceclcno_old,
        target.ceclcid_new,
        target.ceclcno_new,
        target.producer_segment,
        target.date
      ).then(result => {
        if (result.header && result.header.status === "200") {
          this.rechargeRecordDetailData = result.body.record_detail;
        } else {
          this.rechargeRecordDetailData = [];
          if (result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "系統連線異常，請稍候再試" });
          }
        }
        this.registerHanlink()
        this.isRechargeRecordDetailLoading = false;
      });
      this.panelOpen("transferModalOpen");
    },
    openApproveDetailAndGetData(target) {
      switch (target.kind) {
        case "失聯件排除":
          this.approveRecordDetailType = 1;
          this.getLostConfirmDetail(target);
          break;
        case "實質接觸排除":
          this.approveRecordDetailType = 2;
          this.getNoticeExcludeDetail(target);
          break;
        case "未訪件排除":
          this.approveRecordDetailType = 3;
          this.getEstrangeExcludeDetail(target);
          break;
        default:
          this.$toast.info({ title: "覆核原因無法判別，請稍候再試" });
          break;
      }
    },
    getLostConfirmDetail(target) {
      this.isApproveRecordDetailLoading = true;
      this.approveRecordDetailData = [];
      queryLostConfirmDetail(
        this.$store.state.userInfo.id,
        target.clcid,
        target.ceapcno,
        target.clcno,
        target.cfm_date
      ).then(result => {
        if (result.header && result.header.status === "200") {
          this.approveRecordDetailData = result.body.lost_confirm_detail;
        } else {
          if (result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "系統連線異常，請稍候再試" });
          }
        }
        this.isApproveRecordDetailLoading = false;
        this.registerHanlink()
      });
      this.panelOpen("checkModalOpen");
    },
    getNoticeExcludeDetail(target) {
      this.isApproveRecordDetailLoading = true;
      this.approveRecordDetailData = [];
      queryNoticeExcludeDetail(
        this.$store.state.userInfo.id,
        target.clcid,
        target.ceapcno,
        target.clcno,
        target.cfm_date,
        this.$store.state.userInfo.divNo.slice(0, 3)
      ).then(result => {
        if (result.header && result.header.status === "200") {
          this.approveRecordDetailData = result.body.notice_exclude_detail;
        } else {
          if (result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "系統連線異常，請稍候再試" });
          }
        }
        this.isApproveRecordDetailLoading = false;
        this.registerHanlink()
      });
      this.panelOpen("checkModalOpen");
    },
    getEstrangeExcludeDetail(target) {
      this.isApproveRecordDetailLoading = true;
      this.approveRecordDetailData = [];
      queryEstrangeExcludeDetail(
        this.$store.state.userInfo.id,
        target.clcid,
        target.ceapcno,
        target.clcno,
        target.cfm_date
      ).then(result => {
        if (result.header && result.header.status === "200") {
          this.approveRecordDetailData = result.body.estrange_exclude_detail;
        } else {
          if (result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "系統連線異常，請稍候再試" });
          }
        }
        this.isApproveRecordDetailLoading = false;
        this.registerHanlink()
      });
      this.panelOpen("checkModalOpen");
    },
    closeDetailAndOpenContactInfo(target) {
      this.panelClose("checkModalOpen");
      this.getContactInfoData(target);
    },
    getContactInfoData(target) {
      this.isContactInfoLoading = true;
      this.contactInfoData = {};
      queryBelowEstrangePolicyContactInfo(
        this.$store.state.userInfo.id,
        target.ceapcno,
        target.ceapcnm
      ).then(result => {
        if (result.header && result.header.status == "200") {
          this.contactInfoData = result.body.detail;
        } else {
          if (result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "保戶通聯資料查詢失敗,請重新操作" });
          }
        }
        this.isContactInfoLoading = false;
        this.registerHanlink()
      });
      this.panelOpen("connectModalOpen");
    },
    //==================== 初始化功能 ====================
    queryRegionalAllocationRecord() {
      this.isRegionalAllocationRecordLoading = true;
      queryRechargeRecord(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.divNo.slice(0, 3),
        '3',
        this.cedvno3_out,
        this.cedvno3_in
      ).then(result => {
        if (result.header && result.header.status === "200") {
          this.regionalAllocationRecordData = result.body.records;
        } else {
          this.regionalAllocationRecordData = [];
          if (result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "系統連線異常，請稍候再試" });
          }
        }
        this.isRegionalAllocationRecordLoading = false;
        this.registerHanlink()
      });
    },
    queryUnitsAllocationRecord() {
      if(!this.unit_cedvno3){
        this.$toast.info({ title: "請選擇單位" });
        return
      }
      this.isUnitsAllocationRecordLoading = true;
      queryRechargeRecord(
        this.$store.state.userInfo.id,
        this.unit_cedvno3,
        '4',
        '',
        ''
      ).then(result => {
        if (result.header && result.header.status === "200") {
          this.unitsAllocationRecordData = result.body.records;
        } else {
          this.unitsAllocationRecordData = [];
          if (result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "系統連線異常，請稍候再試" });
          }
        }
        this.isUnitsAllocationRecordLoading = false;
        this.registerHanlink()
      });
    },
    getAllUnits(){
      queryRechargeRecord(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.divNo.slice(0, 3),
        '5',
        '',
        ''
      ).then(result => {
        if (result.header && result.header.status === "200") {
          this.allUnits = result.body.records;
        } else {
          this.allUnits = [];
          if (result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "系統連線異常，請稍候再試" });
          }
        }
        this.registerHanlink()
      });
    },
    // initApproveRecord() {
    //   this.isApproveRecordLoading = true;
    //   queryApproveRecord(
    //     this.$store.state.userInfo.id,
    //     this.$store.state.userInfo.divNo.slice(0, 3)
    //   ).then(result => {
    //     if (result.header && result.header.status === "200") {
    //       this.approveRecordData = result.body.approve_record;
    //       this.approveRecordData.sort(this.sortCompareFun("cfm_date", "ceapcnm"));
    //     } else {
    //       this.approveRecordData = [];
    //       if (result.header.message) {
    //         this.$toast.info({ title: result.header.message });
    //       } else {
    //         this.$toast.info({ title: "系統連線異常，請稍候再試" });
    //       }
    //     }
    //     this.isApproveRecordLoading = false;
    //     this.registerHanlink()
    //   });
    // },
    async initTransferTab2() {
      this.queryRegionalAllocationRecord();
      this.getAllUnits()
      //this.initUnitsAllocationRecord();
    },
    // 初始解鎖自招件可撥給非增員者
    initResignUnlockRecord() {
      this.isResignUnlockLoading = true;
      const cedvno3 = this.$store.state.userInfo.divNo.substring(0, 3);
      doQueryResignList(this.$store.state.userInfo.id, cedvno3, "IS_MANGER", null).then(result => {
        this.isResignUnlockLoading = false;
        if (result && result.header.status == "200" && result.body) {
          this.resignUnlockRecord = result.body.rtn_list || [];
        }
      });
    }
  },
  beforeMount() {
    this.initTransferTab2();
  },
  mounted() {}
};
</script>
<style scope>
.label-text-center {
    text-align: center !important;
    padding: 10px 0;
}

.parent {
  position: relative;
}

.child-right {
  position: absolute;
  right: 0;
  padding-top: 10px;
}
</style>
